<template>

    <div class="date-picker-container">

        <form id="add-recipe-to-diet-schedule" method="POST" v-on:submit="submitForm">

            <date-picker v-model="startDatetime" type="datetime" format="D MMMM YYYY" :clearable="false" :lang="lang"
                :class="{ 'is-invalid': attemptSubmit && missingDate }" :append-to-body="false"
                :show-time-panel="showTimePanel" @change="onChangeDatePicker" @open="onOpenDatepicker"
                @close="onCloseDatepicker">
            </date-picker>

            <div class="invalid-feedback">Välj datum år-månad-dag</div>

            <button type="submit" :disabled="waiting && missingDate">
                <svg class="icon icon-plus">
                    <use xlink:href="#icon-plus"></use>
                </svg>
            </button>

            <input type="hidden" name="StartDatum" :value="setDate()" />

        </form>

        <div v-if="waiting" class="modal-popup">
            <p>Vad god vänta...</p>
        </div>

        <div v-if="response && show" class="modal-popup">
            <svg @click="close" v-if="show" class="icon icon-close">
                <use xlink:href="#icon-close"></use>
            </svg>
            <p>{{ response }}</p>
        </div>

    </div>

</template>

<script>

import axios from 'axios';

import 'moment/min/locales';

import DatePicker from 'vue2-datepicker';

import 'vue2-datepicker/locale/sv';

export default {

    components: {
        DatePicker
    },

    props: ['mealIds'],

    data() {
        return {
            attemptSubmit: false,
            startDatetime: new Date(),
            date: null,
            response: false,
            waiting: false,
            show: false,

            showTimePanel: false,
            showTimeRangePanel: false,
            lang: {
                formatLocale: {
                    firstDayOfWeek: 1
                },
                monthBeforeYear: false
            }
        };
    },

    computed: {
        missingDate: function () {
            return this.startDatetime === null;
        }
    },

    mounted() {
        console.log('mealIds', this.mealIds)
    },

    methods: {

        onChangeDatePicker: function (dateString, type) {
            this.date = dateString.toISOString().slice(0, 10)
        },

        onOpenDatepicker: function () {
            this.$nextTick(() => {
                document
                    .querySelector('.mx-datepicker-popup')
                    .addEventListener('click', (e) => e.stopPropagation());
            });
        },

        onCloseDatepicker: function () {
            this.showTimePanel = false;
        },

        empty: function () {
            this.startDatetime = null;
        },

        setDate() {
            return this.date ?? this.startDatetime.toISOString().slice(0, 10)
        },

        async submitForm(e) {

            this.waiting = true;

            $('body').addClass('modal-popup-active');

            this.attemptSubmit = true;

            if (this.missingDate) return e.preventDefault();

            e.preventDefault();

            try {

                await axios.post('/api/matdagboken/meal/store-from-menu-day', {
                    meal_ids: this.mealIds,
                    start_date: this.setDate()
                })

                this.response = 'Veckomenyn har lagts till i din matdagbok.';

            } catch (error) {

                if (error.response) {
                    // Server svarade med status ≠ 2xx
                    console.error(error.response.status, error.response.data);

                } else if (error.request) {
                    // Request skickades men inget svar
                    console.error('Inget svar från servern');
                } else {
                    // Något annat fel
                    console.error(error.message);
                }

                this.response = 'Något har gått fel!';

            } finally {
                this.show = !this.show;
                this.waiting = false;
            }

        },

        close() {
            this.show = !this.show;
            $('body').removeClass('modal-popup-active');
        }
    }
};
</script>
